import {
	GetPlayerWithDailyCheckInRequest,
	GetPlayerWithDailyCheckInResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerWithDailyCheckInReceive } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerWithDailyCheckInReceive(
	payload: GetPlayerWithDailyCheckInRequest,
	props?: UseBaseQueryOptions<GetPlayerWithDailyCheckInResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerWithDailyCheckInReceive, payload],
		queryFn: () => getPlayerWithDailyCheckInReceive(payload),
		...props,
	})
}
